import { render, staticRenderFns } from "./ApprovalTargetCab.vue?vue&type=template&id=20239ad6"
import script from "./ApprovalTargetCab.vue?vue&type=script&lang=js"
export * from "./ApprovalTargetCab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports